import React from 'react';
import classNames from 'classnames';
import I18n from 'i18n-js';

import CoreLink from './core_link';
import { get } from 'lodash';

interface IProps {
  article: any;
  renderForSidebar?: boolean;
  cardStyle?: string;
}

function Placeholder({ renderForSidebar }) {
  if (renderForSidebar) {
    return (
      <div
        className="article-collection-sidebar card article-collection-sidebar-card--placeholder"
      >
        <div className="image-box bg-offwhite" />
        <div className="pl-1" />
      </div>
    );
  }

  return (
    <div
      className="article-collection-card article-collection-card--placeholder"
    >
      <div className="article-collection-card__primary">
        <div
          className="article-collection-card__img"
        />
        <div className="article-collection-card__title" />
      </div>
    </div>
  );
}

export default class ArticleCollectionCard extends React.Component<IProps, null> {
  getCategoryName(article) {
    return get(article, 'articleCategories[0].name') ||
      get(article, 'categories[0].name');
  }

  getURL(article) {
    return get(article, 'webLink.href') ||
      get(article, '_links.web.href');
  }

  getImageURL(article) {
    return get(article, 'images[0].source') ||
      get(article, 'photo');
  }

  getBackgroundImageStyle(article) {
    const src = this.getImageURL(article);
    if (!src) return null;

    return {
      backgroundImage: `url(${src})`,
      // this should be in image-box by default but isn't yet
      backgroundSize: 'cover',
    };
  }

  renderSponsoredContent() {
    if (!this.props.article.partnership_name) return null;

    return (
      <div className="article-collection-card__sponsored_content">
        <div
          className="size-70 style-italic mtb-1 weight-bold opacity-80"
        >
          {I18n.t('commons.sponsoredContentPartner', { partner: this.props.article.partnership_name })}
        </div>
      </div>
    );
  }

  renderForSidebar() {
    const { article } = this.props;

    return (
      <CoreLink
        className="article-collection-sidebar-card"
        to={this.getURL(article)}
        entityId={article.id}
      >
        <div className="fx-width-25 mobile-fx-width-20">
          <div
            className="image-box"
            style={this.getBackgroundImageStyle(article)}
          />
        </div>
        <div className="pl-1">
          <h4 className="size-90">
            {article.title}
          </h4>
        </div>
      </CoreLink>
    );
  }

  render() {
    const { article, renderForSidebar } = this.props;
    if (!article) {
      return <Placeholder renderForSidebar={renderForSidebar} />;
    }

    if (renderForSidebar) return this.renderForSidebar();
    const classes = classNames(
      'article-collection-card',
      { 'article-collection-card--large': this.props.cardStyle === 'large' },
    );

    return (
      <CoreLink
        className={classes}
        to={this.getURL(article)}
        entityId={article.id}
      >
        <div className="article-collection-card__primary">
          <div
            className="article-collection-card__img"
            style={this.getBackgroundImageStyle(article)}
          />
          <h4 className="article-collection-card__title">
            {article.title}
          </h4>
          {this.renderSponsoredContent()}
        </div>
        <div className="article-collection-card__meta">
          <div className="article-collection-card__category">
            {this.getCategoryName(article)}
          </div>
        </div>
      </CoreLink>

    );
  }
}
